var _a, _b, _c, _d, _e, _f, _g, _h;
import { __decorate, __metadata } from "tslib";
import fornecService from "@/core/services/fornecService";
import JwtService from "@/core/services/JwtService";
import { Mutations } from "@/store/enums/StoreEnums";
import { Grau_ExperienciaActions } from "@/store/enums/FornecEnums";
import { Module, Action, VuexModule } from "vuex-module-decorators";
let Grau_ExperienciaModule = class Grau_ExperienciaModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.errors = {};
        this.isAuthenticated = !!JwtService.getToken();
    }
    [_a = Grau_ExperienciaActions.POST_GRAU_EXPERIENCIA](data) {
        return new Promise(resolve => {
            fornecService.post("Grau_Experiencia/Post", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_b = Grau_ExperienciaActions.PUT_GRAU_EXPERIENCIA](data) {
        return new Promise(resolve => {
            fornecService.put("Grau_Experiencia/Put", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_c = Grau_ExperienciaActions.DELETE_GRAU_EXPERIENCIA](data) {
        return new Promise(resolve => {
            fornecService.delete("Grau_Experiencia/Delete", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_d = Grau_ExperienciaActions.DELETE_RANGE_GRAU_EXPERIENCIA](data) {
        return new Promise(resolve => {
            fornecService.delete("Grau_Experiencia/DeleteRange", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_e = Grau_ExperienciaActions.FILTER_GRAU_EXPERIENCIA](data) {
        return new Promise(resolve => {
            fornecService.post("Grau_Experiencia/Filter", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_f = Grau_ExperienciaActions.GET_GRAU_EXPERIENCIA]() {
        return new Promise(resolve => {
            fornecService.get("Grau_Experiencia/Get")
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_g = Grau_ExperienciaActions.GETWITHDISABLED_GRAU_EXPERIENCIA]() {
        return new Promise(resolve => {
            fornecService.get("Grau_Experiencia/GetWithDisabled")
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_h = Grau_ExperienciaActions.GET_BY_ID_GRAU_EXPERIENCIA](data) {
        return new Promise(resolve => {
            fornecService.get("Grau_Experiencia/GetById", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
};
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Grau_ExperienciaModule.prototype, _a, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Grau_ExperienciaModule.prototype, _b, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Grau_ExperienciaModule.prototype, _c, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Grau_ExperienciaModule.prototype, _d, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Grau_ExperienciaModule.prototype, _e, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Grau_ExperienciaModule.prototype, _f, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Grau_ExperienciaModule.prototype, _g, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Grau_ExperienciaModule.prototype, _h, null);
Grau_ExperienciaModule = __decorate([
    Module
], Grau_ExperienciaModule);
export default Grau_ExperienciaModule;
//# sourceMappingURL=Grau_ExperienciaModule.js.map